import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AnnouncementBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#00A3E0] to-[#00FFD1] text-[#0A1628] py-2 px-4 sm:px-6 z-60 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
          <span className="w-2 h-2 rounded-full bg-[#0A1628] animate-pulse flex-shrink-0" />
          <span className="font-bold text-xs sm:text-sm truncate">
            Early Access is now open
          </span>
          <span className="hidden sm:inline text-xs sm:text-sm">—</span>
          <span className="text-xs sm:text-sm hidden sm:inline truncate">
            Limited spots available for founding pilots
          </span>
        </div>
        
        <div className="flex items-center gap-3 sm:gap-4 flex-shrink-0">
          <Link
            to="/waitlist"
            className="text-xs sm:text-sm font-bold hover:underline cursor-pointer whitespace-nowrap"
          >
            Claim your spot →
          </Link>
          <button
            onClick={() => setIsVisible(false)}
            className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center hover:bg-[#0A1628]/10 rounded transition-colors cursor-pointer flex-shrink-0"
            aria-label="Close banner"
          >
            <i className="ri-close-line text-base sm:text-lg" />
          </button>
        </div>
      </div>
    </div>
  );
}
